import { TAGULAR_EVENT_TYPES, TAGULAR_PRODUCT } from "@/types/tagular";
import { tagular } from "@redventures/cohesion-utils-react";
import decodeAndStringifyValue from "../decode-and-stringify-value";
import generateTagularUUID from "./generate-tagular-uuid";

/**
 * Utility: fireProductClicked
 *
 * @see {@link https://app.make.rvapps.io/schemas/sch_1KdMzeZCVB3cFlvsaIXpcvuhBno | ProductClicked Schema}
 */
const fireProductClicked = (
  eventOptions: TAGULAR_PRODUCT,
  callback?: (correlationId: string) => void
) => {
  const {
    variant = "",
    location = "",
    name = "",
    productId = "",
    sku = "",
    category = "",
    price,
  } = eventOptions;
  const correlationId = generateTagularUUID();

  if (!variant && !location) return;

  tagular("beam", {
    "@type": TAGULAR_EVENT_TYPES.PRODUCT_CLICKED,
    product: {
      category: String(category),
      location: String(location),
      name: decodeAndStringifyValue(name),
      productId: String(productId),
      sku: String(sku),
      variant: decodeAndStringifyValue(variant),
      ...(price !== undefined && { price }),
    },
    correlationId,
  });

  // Click Handler
  if (typeof callback === "function") {
    callback?.(correlationId);
  }
};

export default fireProductClicked;
